import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper';
import { Link } from 'react-router-dom';
import { useGetBookmarkHotelCodes, useGetPickOfWeekHotels } from '@/hooks/dataProvider';
import { generateHotelDetailUrl } from '@/urls';
import HotelJapaneseName from './Hotels/HotelJapaneseName';
import HotelStar from './Hotels/HotelStar';
import { useCurrencyFormat } from '@/hooks/useCurrencyFormat';
import { HOTEL_CONFIG } from '@/config';
import HotelBookmarkIcon from './Hotels/HotelBookmarkIcon';
import { useTranslation } from 'react-i18next';

type Props = {};
const nextId = 'PickOfThisWeek_NextId';
const prevId = 'PickOfThisWeek_PrevId';
const pagingId = 'PickOfThisWeek_PagingId';

export default function PickOfThisWeek({}: Props) {
  const { t } = useTranslation();
  const { data: hotels } = useGetPickOfWeekHotels();
  const { formatCurrency } = useCurrencyFormat();
  const { data: bookmarkHotelCodes } = useGetBookmarkHotelCodes();

  if (!hotels?.length) {
    return null;
  }
  return (
    <section className="layout-pt-sm layout-pb-sm">
      <div className="container">
        <div className="row y-gap-10 justify-between items-end">
          <div className="col-auto">
            <div className="sectionTitle -md">
              <h2 className="sectionTitle__title">{t('homeCpn_PickOfTheWeek')}</h2>
            </div>
          </div>
        </div>

        <div className="relative overflow-hidden pt-40 sm:pt-20 js-section-slider item_gap-x30">
          <Swiper
            spaceBetween={20}
            modules={[Navigation, Pagination, Autoplay]}
            autoplay
            navigation={{
              nextEl: `#${nextId}`,
              prevEl: `#${prevId}`,
            }}
            pagination={{
              el: `#${pagingId}`,
              clickable: true,
            }}
            breakpoints={{
              540: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 5,
              },
              1400: {
                slidesPerView: 6,
              },
            }}
          >
            {hotels?.map(hotel => (
              <SwiperSlide key={hotel.hotelCode}>
                <Link to={generateHotelDetailUrl(hotel.hotelName, hotel.hotelCode)} className="hotelsCard -type-1 hover-inside-slider">
                  <div className="hotelsCard__image">
                    <div className="cardImage ratio ratio-1:1">
                      <div className="cardImage__content">
                        <div className="cardImage-slider rounded-4 overflow-hidden custom_inside-slider">
                          <Swiper className="mySwiper" modules={[Navigation]} pagination={false} navigation={true}>
                            {hotel?.images?.length ? (
                              hotel?.images?.map((slide, i) => (
                                <SwiperSlide key={i}>
                                  <img className="w-100 aspect-ratio-1-1 col-12 rounded-4" src={slide} alt="hotel" />
                                </SwiperSlide>
                              ))
                            ) : (
                              <SwiperSlide>
                                <img className="w-100 aspect-ratio-1-1 col-12 rounded-4" src={HOTEL_CONFIG.defaultImage} alt="hotel" />
                              </SwiperSlide>
                            )}
                          </Swiper>
                        </div>
                      </div>
                    </div>
                    {/* End .cardImage */}

                    <div className="cardImage__wishlist">
                      <HotelBookmarkIcon bookmarkHotelCodes={bookmarkHotelCodes} hotelCode={hotel.hotelCode || ''} />
                    </div>

                    <div className="cardImage__leftBadge"></div>
                  </div>
                  <div className="hotelsCard__content mt-10">
                    <h4 className="hotelsCard__title text-dark-1 text-18 lh-16 fw-500">
                      <span>{hotel?.hotelName}</span>
                      <HotelJapaneseName name={hotel.hotelNameJp} addBefore="-" />
                    </h4>

                    <p className="text-light-1 lh-14 text-14 mt-5">{hotel.address}</p>
                    <div className="d-flex items-center">
                      <HotelStar star={hotel.starRating || 0} />
                    </div>
                    <div className="mt-5">
                      <div className="fw-500">
                        Starting from <span className="text-blue-1">{formatCurrency(hotel.cheapestPrice)}</span>
                      </div>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="d-flex x-gap-15 items-center justify-center pt-40 sm:pt-20">
            <div className="col-auto">
              <button className="d-flex items-center text-24 arrow-left-hover" id={prevId}>
                <i className="icon icon-arrow-left" />
              </button>
            </div>
            {/* End .prev */}

            <div className="col-auto">
              <div className="pagination -dots text-border" id={pagingId} />
            </div>
            {/* End .pagination */}

            <div className="col-auto">
              <button className="d-flex items-center text-24 arrow-right-hover" id={nextId}>
                <i className="icon icon-arrow-right" />
              </button>
            </div>
            {/* End .next */}
          </div>
        </div>
      </div>
    </section>
  );
}
